<template>
    <div class="menu-toggle-wrapper"
         :class="{ 'd-none': menuStore.isDesktop, 'active': menuStore.isMobileNavOpen }"
         @click="toggleMobileNav">
        <div class="menu-toggle-container">
            <div class="menu-toggle" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useMenuStore } from '@/js/store/menu/MenuStore';

    const menuStore = useMenuStore();

    const toggleMobileNav = () => {
        const topMenu = document.querySelector('.top-menu');
        const navbar = document.getElementById('header-navigation-container');
        const topMenuPromotionalBar = document.querySelector('.top-menu-promotional-bar');

        menuStore.isMobileNavOpen = !menuStore.isMobileNavOpen;

        document.body.classList.toggle('nav-active');

        if (topMenuPromotionalBar) {
            topMenuPromotionalBar.classList.toggle('nav-active');
        }

        if (topMenu) {
            topMenu.classList.toggle('nav-active');
        }

        if (navbar) {
            navbar.classList.toggle('nav-active');
        }
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;

.menu-toggle-wrapper {
    padding: 10px 10px 10px 8px;
    margin: 0 -10px 0 5px;

    .menu-toggle-container {
        position: relative;
        width: 22px;
        height: 16px;
        cursor: pointer;

        .menu-toggle {
            position: absolute;
            top: 8px;
            width: 100%;
            height: 2px;
            border-radius: 4px;
            background-color: legacyVariables.$light-grey-blue;
            transition: transform 350ms ease 0s, background-color 0s cubic-bezier(0.6, 0, 0.15, 1) 0s;

            &::before {
                position: absolute;
                display: block;
                width: 100%;
                height: 2px;
                border-radius: 4px;
                background-color: legacyVariables.$light-grey-blue;
                content: "";
                transform: translateY(-8px);
                transition: transform 300ms ease 0s, background-color 0s cubic-bezier(0.6, 0, 0.15, 1) 0s;
            }

            &::after {
                position: absolute;
                display: block;
                width: 100%;
                height: 2px;
                border-radius: 4px;
                background-color: legacyVariables.$light-grey-blue;
                content: "";
                transform: translateY(8px) rotate(0deg);
                transition: transform 300ms ease 0s, background-color 0s cubic-bezier(0.6, 0, 0.15, 1) 0s;
            }
        }
    }

    &.active {
        .menu-toggle {
            transform: rotate(45deg);

            &::before {
                transform: translateY(0);
            }

            &::after {
                transform: translateY(0) rotate(-90deg);
            }
        }
    }
}
</style>
